import { createAction } from "redux-act";
// ------EasyInvest---
export const REQAnalyticList = createAction("REQUEST_ANALYTIC_LIST");
export const RESAnalyticList = createAction("RECEIVE_ANALYTIC_LIST");
export const FailAnalyticList = createAction("FAILED_ANALYTIC_LIST");
export const CleanUpAnalyticList = createAction("CLEANUP_ANALYTIC_LIST");

// ------UntHld---
export const REQAnalyticUntHldList = createAction("REQUEST_ANALYTIC_UNTHLD_LIST");
export const RESAnalyticUntHldList = createAction("RECEIVE_ANALYTIC_UNTHLD_LIST");
export const FailAnalyticUntHldList = createAction("FAILED_ANALYTIC_UNTHLD_LIST");
export const CleanUpAnalyticUntHldList = createAction("CLEANUP_ANALYTIC_UNTHLD_LIST");

// ------PVD---
export const REQAnalyticPVDList = createAction("REQUEST_ANALYTIC_PVD_LIST");
export const RESAnalyticPVDList = createAction("RECEIVE_ANALYTIC_PVD_LIST");
export const FailAnalyticPVDList = createAction("FAILED_ANALYTIC_PVD_LIST");
export const CleanUpAnalyticPVDList = createAction("CLEANUP_ANALYTIC_PVD_LIST");

// ------PVD Excel Download---
export const REQAnalyticPVDExcelDownload = createAction("REQUEST_ANALYTIC_PVD_EXCEL_DOWNLOAD");
export const RESAnalyticPVDExcelDownload = createAction("RECEIVE_ANALYTIC_PVD_EXCEL_DOWNLOAD");
export const FailAnalyticPVDExcelDownload = createAction("FAILED_ANALYTIC_PVD_EXCEL_DOWNLOAD");
export const PROGRESSAnalyticPVDExcelDownload = createAction("PROGRESS_ANALYTIC_PVD_EXCEL_DOWNLOAD");
export const CleanUpAnalyticPVDExcelDownload = createAction("CLEANUP_ANALYTIC_PVD_EXCEL_DOWNLOAD");